import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DiagnosticOrderService } from '@ispm/dashboard/test/services/diagnostic-order.service';
import { UICustomizationService } from '@ispm/shared/services/ui-customization.service';
import { WorkflowConfigService } from '@ispm/workflow/services/workflow-config.service';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { UserService } from '@ispm/user/services/user.service';
import { DynamicModalAbstractComponent } from '../../../classes/dynamic-modal-abstract-component';
import { DynamicModalLoaderService } from '../../../services/dynamic-modal-loader.service';
import { PractitionerService } from '@ispm/migration/services/practitioner.service';
import { ActivityService } from '@ispm/user/services/activity.service';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import { WorkflowService } from '@ispm/workflow/services/workflow.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import { IgenomicsState } from "@ispm/core/interfaces/genomics-state.interface";
import { Store } from '@ngrx/store';
import { ActivityActions } from "@ispm/user/constants/activityActions";

@Component({
  selector: 'gen-reassign-test-modal',
  templateUrl: './reassign-test-modal.component.html',
  styleUrls: ['./reassign-test-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReassignTestModalComponent extends DynamicModalAbstractComponent implements OnInit {

  readonly Reassign_Test: string = 'ReassignTest';
  readonly Reassign_Test_By_Role: string = 'ReassignTestByRole';
  readonly Reassign_Curation: string = 'ReassignCuration';
  readonly Remove_Modal: string = 'ReamoveModal';
  readonly VALUE_NONE: string = 'None';

  public ngDialogData: any; // modal data passes from the component
  public practitionerSelectorForm: any;
  public additionalSearchValues: any;
  public testIsArchieved: boolean;
  public selectedPractId: any;
  public originalPractitioner: any;
  public practitionerId: any;
  public tempPractId: any;
  public selectedPractObject: any;
  public reassignNote: any;
  public reassigninginProgress: boolean;
  public reassigning: any;
  public reassignFinished: boolean;
  public reassignFailed: boolean;
  public selectedOpt: string;
  public testOrIteam: string;
  public assigneeRole: string = 'None';
  public roleObj: any;
  public practitionersByRole = { };
  public practitionerSelectorFormCurationItem: any;
  private bulkOperationMode: boolean;
  private showWarningMessageForReassignOperation: boolean = false;
  private opinionsInReviewStateWithSelections: any;
  private pracOpinionName: string;
  private currentApp: string
  private autoSelect: boolean;
  public titlePrefix: string = 'Reassign ';
  public exceededTestsAmount: boolean;
  public maxItemsCount: number;


  constructor(
    modalLoaderService: DynamicModalLoaderService,
    public userService: UserService,
    public uICustomizationService: UICustomizationService,
    private authService: AuthenticationService,
    private practitionerService: PractitionerService,
    private workflowService: WorkflowService,
    private diagnosticOrderService: DiagnosticOrderService,
    private notificationMessageService: NotificationMessageService,
    public translateService: TranslateService,
    public workflowConfigService: WorkflowConfigService,
    public activityService: ActivityService,
    private store: Store<IgenomicsState>,
    private _changeDetector: ChangeDetectorRef
    ) {
    super(modalLoaderService);
  }

  onNext(payload: any): void {
    this.ngDialogData = payload && payload['content'] || '';
  }

  onError(error): void {
  }

  onComplete(): void {
  }

  ngOnInit() {
    this.bulkOperationMode = this.ngDialogData.bulkOperationMode;
    this.exceededTestsAmount = this.ngDialogData.exceededTestsAmount; //Notify the user that not all tests will be reassign
    this.maxItemsCount = this.ngDialogData.maxItemsCount;
    this.practitionerId = this.authService.getUser() ? this.authService.getUser().info.id : null;
    this.testOrIteam = this.ngDialogData.modalName === this.Reassign_Test_By_Role ? 'Test' : 'Item';

    if (this.bulkOperationMode){
      this.titlePrefix = '';
    }

    if (this.ngDialogData.modalName !== this.Remove_Modal) {
      // for Reassign_Test & Reassign_Test_By_Role
      if (this.ngDialogData.modalName !== this.Reassign_Curation) {
        this.initDialog();
      } else {
        this.initCurationItemDialog();
      }
    }

    if (this.selectedPractId === this.VALUE_NONE) {
      this.selectedOpt = 'value2';
    } else if (this.selectedPractId === this.practitionerId) {
      this.selectedOpt = 'value1';
    }

    this.store.select('navigation', 'currentApp').subscribe((app) => {
      this.currentApp = app?.id;
    });

    if (this.currentApp === "ISPM-PATHOLOGY-GENOMICS-APP" && !this.bulkOperationMode && this.ngDialogData.modalName === this.Reassign_Test) {
      this.workflowService.testHasSecondOpinion(this.ngDialogData.analysis.activeRevision).subscribe((opinions: any) => {
        this.opinionsInReviewStateWithSelections = _.find(opinions, (op) => {
          return op.state === 'review' && op.order == 1 && !this.isEmptyObj(op.selections);
        })
        this.showWarningMessageForReassignOperation = !!this.opinionsInReviewStateWithSelections && this.checkCaseWithAutoSelectAberration();
        if (this.showWarningMessageForReassignOperation) {
          this.setPracOpinionName();
        }
      })
    }
  }

  checkCaseWithAutoSelectAberration() {
    let opinion = this.opinionsInReviewStateWithSelections;
    if (opinion.hasOwnProperty('autoSelections')) {
      if (this.objectsContainSameObjects(opinion.selections, opinion.autoSelections)) {
        this.autoSelect = true;
        return false
      }
    }
    return true;
  }

  objectsContainSameObjects(obj1, obj2)  {
    if (!obj1 || !obj2) return false;
    const keys1 = Object.keys(obj1).sort();
    const keys2 = Object.keys(obj2).sort();
    if (!_.isEqual(keys1, keys2)) return false;
    return _.every(keys1, key => _.isEqual(obj1[key], obj2[key]));
  }

  initDialog() {
    this.practitionerSelectorForm = this.userService.getPractitionerInputForm(['$(searchTerm.additionalData.role)'],
    this.ngDialogData.practitionerFilterBy, this.translateService.instant('SELECT_AN_ASSIGNEE') || 'Select an assignee' ,
    this.authService.getUser().info.id, false, true);

    this.setOriginalPractitioner();
    this.additionalSearchValues = { role: this.ngDialogData.practitionerRoles.join(',')};

    if (this.ngDialogData.modalName === this.Reassign_Test_By_Role) { // this part was deprecated
      for (const role of this.ngDialogData.practitionerRoles) {
        this.practitionerService.getPractitionersByRole(role).subscribe((practitioners) => {
          this.practitionersByRole[role] =
          this.filterPractitionerList(this.workflowService.currentTest, practitioners,
            this.practitionerId, this.testIsArchieved);
          const selectedRole = this.ngDialogData.analysis[role.toLowerCase()];
          if (selectedRole) {
            const selected = practitioners.find((practitioner) => practitioner.id === selectedRole.id);
            if (selected) {
              this.setReassignPractitioner(selected);
            }
            this.roleObj[role + 'tempId'] = selected ? selected.id : null;
          }
        });
      }
    }
  }

  initCurationItemDialog() {
    this.practitionerSelectorFormCurationItem = this.userService.getPractitionerInputForm(this.ngDialogData.disallowedPractitionerRoles,
      undefined, this.translateService.instant('SELECT_AN_ASSIGNEE') || 'Select an assignee', this.authService.getUser().info.id, true, true);

    this.workflowConfigService.getActiveWorkflow()
      .filter(workflowRequest => !!workflowRequest)
      .take(1)
      .subscribe(workflowRequest => {
        this.setOriginalPractitionerForAll(workflowRequest);
      });
  }

  filterPractitionerList(analysis: any, pathologists: any, practitionerId: any, filterPerformer = true) {
    let reference: any;
    let secondOpinionerId: any;

    if (this.bulkOperationMode){
      return pathologists;
    }
    analysis.workflowRequest.references.forEach((ref) => {
      if (ref.key === 'practitioner') {
        reference = JSON.parse(ref.value);
        if (reference.practType === '2ndOpinion') {
          secondOpinionerId = reference.practId;
        }
      }
    });
    return _.filter(pathologists, function (pract) {
      return (!filterPerformer) || (filterPerformer && pract.id !== analysis.performer)
        && pract.id !== secondOpinionerId
        && pract.id !== practitionerId;
    });
  }

  setReassignPractitioner(practitioner: any) {
    if (!practitioner) {
      return;
    }
    this.tempPractId = practitioner.id;
    this.selectedPractObject = { practitioner: practitioner };
    this.setSelectedPractId(this.tempPractId, 'value3');
  }

  setOriginalPractitioner() {
    if (this.bulkOperationMode){
      return;
    }
    this.setOriginalPractitionerForAll(this.workflowService.currentTest.workflowRequest);
    this.testIsArchieved = this.workflowService.currentTest.workflowRequest.hasOwnProperty('activeWorkflow') ?
    !this.workflowService.currentTest.workflowRequest.activeWorkflow : false;
  }

  setOriginalPractitionerForAll(workflowRequest) {
    let value: any;
    for (const ref of workflowRequest.references) {
      if (ref.type.toLowerCase() === 'practitioner') {
        value = JSON.parse(ref.value);
        if (value.practType === 'performer') {
          this.selectedPractId = value.practId;
          this.originalPractitioner = JSON.parse(JSON.stringify(this.selectedPractId));
        }
      }
    }
  }

  assignToMeStatusForTestIsDisabled(): any {
    return ((!this.testIsArchieved && this.originalPractitioner === this.practitionerId) ||
    this.assignToMeStatusIsDisabled());
  }

  assignToMeStatusIsDisabled(): boolean {
    return this.optionSelectionDisabled() || !this.ngDialogData.enableReassign;
  }

  optionSelectionDisabled(): any {
    return this.uICustomizationService.getUICustomResourceProperty('reassign-to-me-option', 'disabled');
  }

  assignToPoolStatusIsDisabled(): boolean {
    return !this.testIsArchieved && this.originalPractitioner === 'None';
  }

  private isEmptyObj(obj) {
    for (var key in obj) {
      if (obj[key])
        return false;
    }
    return true;
  }

  private setPracOpinionName() {
    if (this.practitionerId === this.opinionsInReviewStateWithSelections.practitioner.reference) {
      this.pracOpinionName = "Your";
    } else {
      this.practitionerService.get(this.opinionsInReviewStateWithSelections.practitioner.reference).subscribe((res) => {
        let name = res.body.name[0];
        this.pracOpinionName = name.prefix[0] + ' ' + name.given[0] + ' ' + name.family[0] + '\'s';
      });
    }
  }

  private assignFromPoolToUser() {
    if (this.assignToPoolStatusIsDisabled()) {
      if (this.opinionsInReviewStateWithSelections && this.selectedPractId != this.opinionsInReviewStateWithSelections.practitioner.reference) {
        if (this.practitionerId === this.opinionsInReviewStateWithSelections.practitioner.reference) {
          this.setPracOpinionName();
          this.showWarningMessageForReassignOperation = true;
        } else {
          if (this.selectedPractId) {
            this.setPracOpinionName();
            this.showWarningMessageForReassignOperation = true;
          } else {
            this.showWarningMessageForReassignOperation = false;
          }
        }
      } else {
        this.showWarningMessageForReassignOperation = false;
      }
    }
  }

  reassignTest(analysis: any): any {
    if (this.bulkOperationMode){
      this.closeThisDialog({selectedPractId: this.selectedPractId, reassignNote: this.reassignNote});
      return;
  }

    this.reassigninginProgress = true;
    this._changeDetector.markForCheck();
    if (this.selectedPractId) {
      if (this.ngDialogData.modalName !== this.Reassign_Curation) {
    this.reassigning = this.workflowService.reassignTest(analysis, this.selectedPractId, true, this.autoSelect)
      .then(() => {
        if (this.reassignNote) {
          const curreRevision = analysis.activeRevision !== 'None' ? analysis.activeRevision : analysis.lastRevision;
          return this.diagnosticOrderService.createTestAssignNote(analysis.workflowrequest_id, curreRevision, this.reassignNote)
            .subscribe((note) => {
                if (note) {
                  this.activityService.create(
                    {
                      actor: {
                        reference: note.body.actor.id,
                        resourceType: note.body.actor.resourceType
                      },
                      context: [{
                        reference: note.body.id,
                        resourceType: 'Note'
                      }],
                      action: ActivityActions.READ
                    })
                    .subscribe(() => {
                      this.reassigninginProgress = false;
                      this.reassignFinished = true;
                      this._changeDetector.markForCheck();
                    });
                }
              },
              () => {
                this.notificationMessageService.error('error while adding note');
              });
        } else {
          this.reassigninginProgress = false;
          this.reassignFinished = true;
        }
        analysis.reassignFinished = true;
        this._changeDetector.markForCheck();
      })
      .catch(() => {
        this.reassigninginProgress = false;
        this.reassignFailed = true;
        this._changeDetector.markForCheck();
        this.notificationMessageService.error('error while trying to reassign the test');
      });
    return this.reassigning;
      } else {
        return this.reassignCurationItem(analysis);
      }
    }
    return;
  }

  reassignCurationItem(analysis: any): any {
    this.reassigning = this.workflowService.reassignCurationItem(analysis, this.selectedPractId)
      .then(() => {
        if (this.reassignNote) {
          const curreRevision = analysis.activeRevision !== 'None' ? analysis.activeRevision : analysis.lastRevision;
          this.diagnosticOrderService.createTestAssignNote(analysis.workflowrequest_id, curreRevision, this.reassignNote)
            .subscribe((note) => {
              if (note) {
                this.activityService.create(
                  {
                    actor: {
                      reference: note.body.actor.id,
                      resourceType: note.body.actor.resourceType
                    },
                    context: [{
                      reference: note.body.id,
                      resourceType: 'Note'
                    }],
                    action: ActivityActions.READ
                  })
                  .subscribe(() => {
                    this.reassigninginProgress = false;
                    this.reassignFinished = true;
                    this._changeDetector.markForCheck();
                  });
              }
            },
              () => {
                this.notificationMessageService.error('error while adding note');
            });
        }
        else {
          this.reassigninginProgress = false;
          this.reassignFinished = true;
        }
        analysis.reassignFinished = true;
        this._changeDetector.markForCheck();
      }).catch(() => {
        this.reassigninginProgress = false;
        this.reassignFailed = true;
        this._changeDetector.markForCheck();
        this.notificationMessageService.error('error while trying to reassign the test');
      });
    return this.reassigning;
  }

  onAssigneeTypeClick(role: any, practitionerId: any) {
    this.assigneeRole = role;
    this.selectedPractId = practitionerId;
    this._changeDetector.markForCheck();
  }

  assignToMeStatusForNonTestIsDisabled() {
    return (this.originalPractitioner === this.practitionerId) || this.assignToPoolStatusIsDisabled();
  }

  setSelectedPractId(id: any, value: string) {
    this.selectedPractId = id ? JSON.parse(JSON.stringify(id)) : undefined;
    this.assignFromPoolToUser();
    this.selectedOpt = value;
    this._changeDetector.markForCheck();
  }

  closeThisDialog(payload: any) {
    super.close(payload);
  }

}
